import { get } from 'lodash'
export default async (id: string, apiKey: string): Promise<any> => {
  const response = await fetch(`https://internal.tv4.incomet.io/metadata/programs?nid=${id}&apikey=${apiKey}`)
  const result = await response.json()
  const data = get(result, 'data')
  return data.length > 0 ? result.data[0] : null
}
